module.exports = __webpack_public_path__ + "static/media/Right 4-2.f24a6d02.svg";